import { useAppDispatch, useAppSelector } from "./reduxHooks";
import {
  BodyPostSolicitudDemanda,
  BodySolicitudDemanda,
  Instancia,
  Juicio,
  Materia,
  Oficialia,
  Region,
  Via,
  BodyUpdateSolicitudDemanda,
  DataSolicitudResponse,
} from "interfaces/demandas/demandasInterface";
import {
  deleteFileUploadded,
  deleteSolicitudDemanda,
  getAcuseDemandas,
  getFiles,
  getInstanciasOficialiaDemandas,
  getJuicios,
  getMaterias,
  getOficialiaPoregiones,
  getPermisoJuicios,
  getRegiones,
  getSolicitudDemandaById,
  getSolicitudesDemandas,
  getSolicitudesDemandasLaborales,
  getViasMateria,
  postMoveSolicitudToDemanda,
  postSolicitudDemanda,
  postUploadFile,
  putUpdateSolicitudDemanda,
} from "services/demandasServices/demandasService";
import {
  onAddCapturaPartesActores,
  onAddCapturaPartesDemandados,
  onAddDocumentosListDemanda,
  onAddDocumentSelected,
  onAddFileStep,
  onAddFormNotas,
  onAddFormSolicitudDemandas,
  onAddInitialActoresPartes,
  onAddInitialDemandadosPartes,
  onAddInstanciaId,
  onAddInstancias,
  onAddJuicioId,
  onAddJuicios,
  onAddListUploaddedFiles,
  onAddMateriaId,
  onAddMaterias,
  onAddOficialiaId,
  onAddOficialias,
  onAddRegiones,
  onAddRegionId,
  onAddSolicitudDemandaRes,
  onAddSolicitudDemandaSelected,
  onAddStepDemanda,
  onAddTipoModalidad,
  onAddViaId,
  onAddVias,
  onAllResetStateDemandas,
  onChangeTipoModalidad,
  onCompleteStepOne,
  onPermisoJuicios,
  onResetSelectsDemanda,
  onShowModalVisor,
  onSolicitudesDemandas,
  onSolicitudesDemandasLaborales,
  onSuccessMoveSolcitudToDemanda,
  onUpdateListSolicitudDemanda,
} from "store/demandas/demandasSlice";
import { useUiStore } from "./useUiStore";
import { CapturaPartesInterface } from "interfaces/capturaPartes/capturaPartesInterface";
import { setIsLoading, setMessageLoading, setOpenSnackBar } from "store";
import { listaErrores, mergeArrays } from "helpers/helpers";
import { listaErroresFirma, orderListAsc } from "utils/_generals";
import {
  FileArgs,
  FileBase64,
} from "interfaces/serviciosGenerales/serviciosGeneralesInterface";
import { useVisorDocumentosStore } from "./useVisorDocumentosStore";
import Swal from "sweetalert2";
import { createIframe } from "utils/_createIframeBlobUrl";
import { getFile } from "services/serviciosGenerales/serviciosGenerales";
import { ValidateStatus } from "components/componentesGenerales/firmaElectronica/interfaces/firmaInterfaces";
import { generateRamdomId } from "utils/_generateRandomId";
import localforage from "localforage";
import { usePeriodosInactividad } from "./periodosInactividad/usePeriodosInactividad";

export const useDemandaStore = () => {
  const dispatch = useAppDispatch();
  const { changeTotalPage } = useUiStore();
  const {
    lstRegiones,
    lstOficialias,
    lstMaterias,
    lstInstancias,
    lstVias,
    lstJuicios,
    cveRegion,
    tipoModalidad,
    stepDemanda,
    solicitudesDemandas,
    solicitudDemandaRes,
    solicitudesDemandasLaborales,
    formSolicitudDemanda,
    formNotas,
    capturaPartesDemandados,
    capturaPartesActores,
    file,
    listUploaddedFiles,
    showModalVisor,
    documentSelected,
    cveOficialia,
    cveMateria,
    cveInstancia,
    cveVia,
    cveJuicio,
    successMoveSolicitudToDemanda,
    solicitudDemandaSelected,
    initialCapturaParteActores,
    initialCapturaParteDemandados,
    solicitudDemandaDocumentos,
    modalPermisoLiti,
  } = useAppSelector((state) => state.demandas);
  const { openVisorDocumentos, addDocumentPDF, addDocumentoSeleccionado, addDocumentos, addPosicion } =
    useVisorDocumentosStore();
  const { optionsSnackBar } = useUiStore();
  const { dataPeriodosInactividad } = usePeriodosInactividad();
  const startGetRegiones = () => {
    dispatch(onAddRegiones([]));
    addRegionId(null);
    getRegiones()
      .then(({ data }) => {
        const regionesList = orderListAsc(data.data, "NomRegion");
        const dataListRegiones = regionesList.map((region: Region) => {
          let body = {
            label: region.NomRegion,
            value: region.CveRegion,
            ...region,
          };
          return body;
        });
        dispatch(onAddRegiones(dataListRegiones));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const startGetOficialiaPorRegiones = (cveRegion: number) => {
    dispatch(onAddOficialias([]));
    addOficialiaId(null);
    getOficialiaPoregiones(cveRegion)
      .then(({ data }) => {
        const oficialiasList = orderListAsc(data.data, "desJuz");
        const dataListOficialias = oficialiasList.map(
          (oficialia: Oficialia) => {
            let body = {
              label: oficialia.desJuz,
              value: oficialia.IdJuzgado,
              ...oficialia,
            };
            return body;
          }
        );
        dispatch(onAddOficialias(dataListOficialias));
      })
      .catch((err) => {
        console.log(err);
        if (typeof err.response.data.data === "string") {
          dispatch(
            onAddOficialias([{ label: err.response.data.data, value: 0 }])
          );
          return;
        }
      });
  };

  const startGetMaterias = (cveOficialia: number) => {
    dispatch(onAddMaterias([]));
    addMateriaId(null);
    getMaterias(cveOficialia)
      .then(({ data }) => {
        const materiasList = orderListAsc(data.data, "descMateria");
        const dataListMaterias = materiasList.map((materia: Materia) => {
          let body = {
            label: materia.descMateria,
            value: materia.cveMateria,
            ...materia,
          };
          return body;
        });
        dispatch(onAddMaterias(dataListMaterias));
      })
      .catch((err) => {
        if (typeof err.response.data.data === "string") {
          dispatch(
            onAddMaterias([{ label: err.response.data.data, value: 0 }])
          );
          return;
        }
        console.log(err);
      });
  };

  const startGetInstancias = (cveOficialia: number) => {
    dispatch(onAddInstancias([]));
    addInstanciaId(null);
    if (!cveOficialia) {
      dispatch(
        onAddInstancias([
          {
            label: "No Existe información para el recurso solicitado",
            value: 0,
          },
        ])
      );
      return;
    }
    getInstanciasOficialiaDemandas(cveOficialia)
      .then(({ data }) => {
        const instanciasList = orderListAsc(data.data, "descInstancia");
        const dataListInstancias = instanciasList.map(
          (instancia: Instancia) => {
            let body = {
              label: instancia.descInstancia,
              value: instancia.cveInstancia,
              ...instancia,
            };
            return body;
          }
        );
        dispatch(onAddInstancias(dataListInstancias));
      })
      .catch((err) => {
        if (typeof err.response.data.data === "string") {
          dispatch(
            onAddInstancias([{ label: err.response.data.data, value: 0 }])
          );
          return;
        }
        console.log(err);
      });
  };

  const startGetVias = (cveMateria: number, withHistoricos = "") => {
    dispatch(onAddVias([]));
    addViaId(null);
    getViasMateria(cveMateria, withHistoricos)
      .then(({ data }) => {
        const viasList = orderListAsc(data.data, "descModalidad");
        const dataListVias = viasList.map((via: Via) => {
          let body = {
            label: via.descModalidad,
            value: via.cveModalidad,
            ...via,
          };
          return body;
        });
        dispatch(onAddVias(dataListVias));
      })
      .catch((err) => {
        if (typeof err.response.data.data === "string") {
          dispatch(onAddVias([{ label: err.response.data.data, value: 0 }]));
          return;
        }
        console.log(err);
      });
  };

  const startGetJuicios = (cveMateria: number, cveModalidad: number) => {
    dispatch(onAddJuicios([]));
    addJuicioId(null);
    if (!cveMateria || !cveModalidad) {
      dispatch(
        onAddInstancias([
          {
            label: "No Existe información para el recurso solicitado",
            value: 0,
          },
        ])
      );
      return;
    }
    getJuicios(cveMateria, cveModalidad)
      .then(({ data }) => {
        const juiciosList = orderListAsc(data.data, "descLiti");
        const dataListJuicios = juiciosList.map((juicio: Juicio) => {
          let body = {
            label: juicio.descLiti,
            value: juicio.cveLiti,
            ...juicio,
          };
          return body;
        });
        dispatch(onAddJuicios(dataListJuicios));
      })
      .catch((err) => {
        if (typeof err.response.data.data === "string") {
          dispatch(onAddVias([{ label: err.response.data.data, value: 0 }]));
          return;
        }
        console.log(err);
      });
  };

  const startPermisosJuicios = (cveAdscripcion: number, cveLiti: number) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Consultando..."));
    getPermisoJuicios(cveAdscripcion, cveLiti)
      .then(({ data }) => {
        if (data?.data?.permitir === "N") {
          onModalPermisoLiti(true);
        } else {
          onModalPermisoLiti(false);
        }
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      })
      .catch((err) => {
        console.log(err);
        onModalPermisoLiti(false);
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      });
  };

  const startGetSolicitudesDemandas = (body: BodySolicitudDemanda) => {
    dispatch(setIsLoading(true));
    getSolicitudesDemandas({ ...body })
      .then(({ data }) => {
        changeTotalPage(data.data.total);
        const demandasList = data.data.data.map((demanda) => {
          let body = {
            ...demanda,
            materia: demanda?.materias?.descMateria,
            desJuz: demanda?.juzgado?.DesJuz,
            estatus: demanda?.idcarpetaJudicial ? "ENVIADA" : "CAPTURANDO",
          };
          return body;
        });
        dispatch(onSolicitudesDemandas(demandasList));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setIsLoading(false));
      });
  };

  const startGetSolicitudesDemandasLaborales = (body: BodySolicitudDemanda) => {
    dispatch(setIsLoading(true));
    getSolicitudesDemandasLaborales({ ...body })
      .then(({ data }) => {
        changeTotalPage(data.data.totalCount);
        dispatch(onSolicitudesDemandasLaborales(data.data.data));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setIsLoading(false));
      });
  };

  const startSaveStepOne = (body: BodyPostSolicitudDemanda) => {
    if (dataPeriodosInactividad?.descInactividad && cveOficialia !== 11585) {
      Swal.fire({
        title: "No es posible continuar",
        html: `
          <style>
            .swal2-container {
              z-index: 99999
            }
          </style>
          <p>${dataPeriodosInactividad?.descInactividad}</p>`,
        icon: "warning",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#801313",
      });
      return;
    }
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Guardando solicitud demanda"));
    postSolicitudDemanda(body)
      .then(({ data }) => {
        let bodyResponse = {
          ...data.data,
          actores: data.data.actores.map((actor) => {
            let body = {
              ...actor,
              id: generateRamdomId(),
            };
            return body;
          }),
          demandados: data.data.demandados.map((demandado) => {
            let body = {
              ...demandado,
              id: generateRamdomId(),
            };
            return body;
          }),
          idsCombos: {
            cveRegion: cveRegion,
            cveOficialia: cveOficialia,
            cveMateria: cveMateria,
            cveInstancia: cveInstancia,
            cveVia: cveVia,
            cveJuicio: cveJuicio,
            juzgadoEnLinea: tipoModalidad,
          },
        };
        localforage.setItem("idSolicitud", JSON.stringify(bodyResponse));
        localforage.setItem("currentStep", JSON.stringify(stepDemanda + 1));
        addSolicitudDemanda(bodyResponse);
        addStepDemanda(stepDemanda + 1);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
        addFormNotas(null);
        addFormSolicitudDemandas(null);
        dispatch(
          setOpenSnackBar({
            status: true,
            message: bodyResponse.mensaje,
          })
        );
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: `Ha ocurrido un error al guardar  el reporte`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
          <style>
          h4, h5{
            font-family: arial;
            color: #545454;
          }
        </style>
          <h4>${err?.response?.data?.data || "Hubo un problema"}</h4>
          <h5>${err?.response?.data?.error_data || "Hubo un problema"}</h5>
          <div id="lista-errores"></div>
         `,
        });
        listaErrores(err);
        addFormNotas(null);
        addFormSolicitudDemandas(null);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      });
  };

  const startUploadFileDemanda = () => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Subiendo Archivo"));

    let totalSize = listUploaddedFiles.reduce(
      (acumulador: number, actual: FileArgs) =>
        Number(acumulador) + Number(actual.size),
      0
    ); /* @ts-ignore */
    let totalSizePayload = file.reduce(
      (acumulador: number, actual: FileArgs) =>
        Number(acumulador) + Number(actual.size),
      0
    );

    /* @ts-ignore */
    const totalWithNewFile = Number(totalSizePayload) + totalSize;
    const totalTamañoDisponible = (totalWithNewFile / 30) * 100;

    if (totalTamañoDisponible > 100) {
      dispatch(
        setOpenSnackBar({
          status: true,
          message: "Los archivos superan los 30MB permitidos",
        })
      );
      dispatch(setIsLoading(false));
      setTimeout(() => {
        dispatch(setMessageLoading(""));
      }, 500);
      return;
    }

    let body = {
      idSolicitudDemanda: solicitudDemandaRes?.resultados.idSolicitudActuacion,
      documents: file,
    };
    postUploadFile(body)
      .then(({ data }) => {
        /* @ts-ignore */
        const listFilesMerge = mergeArrays(data.data.files, file);
        const listFiles = [...listUploaddedFiles, ...listFilesMerge];
        const list = listFiles.map(({ content, ...args }) => {
          return args;
        });
        localforage.setItem("listFiles", JSON.stringify(list));
        addListFiles(listFiles);
        dispatch(setIsLoading(false));
        dispatch(
          setOpenSnackBar({
            status: true,
            message: "Se subió el archivo correctamente",
          })
        );
        setTimeout(() => {
          dispatch(setMessageLoading(""));
        }, 500);
      })
      .catch((err) => {
        console.log(err);
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
        Swal.fire({
          title: "Ocurrio un problema al subir el archivo",
          text: err.response.data.data,
          icon: "error",
        });
      });
  };

  const startGetFile = (params: { path: string }) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Cargando Archivo"));
    getFiles(params)
      .then(({ data }) => {
        const fileUrl = window.URL.createObjectURL(
          new Blob([data], { type: "application/pdf" })
        );
        addDocumentPDF([fileUrl]);
        addDocumentoSeleccionado(fileUrl);
        dispatch(setIsLoading(false));
        setTimeout(() => {
          dispatch(setMessageLoading(""));
        }, 500);
        openVisorDocumentos(true);
      })
      .catch((err) => {
        console.log(err);
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      });
  };

  const startDeleteFile = (file: FileArgs) => {
    dispatch(setMessageLoading("Eliminando Archivo"));
    dispatch(setIsLoading(true));
    let body = {
      path: file.path,
      idFirmaDocumento: file.idFirmaDocumento,
    };
    deleteFileUploadded(body)
      .then(({ data }) => {
        const updatedList = listUploaddedFiles.filter(
          (fileUploadded: any) => fileUploadded.digestion !== file.digestion
        );
        localforage.setItem("listFiles", JSON.stringify(updatedList));
        addListFiles(updatedList);
        dispatch(setIsLoading(false));
        dispatch(
          setOpenSnackBar({
            status: true,
            message: data.data.message,
          })
        );
        setTimeout(() => {
          dispatch(setMessageLoading(""));
        }, 500);
      })
      .catch((err) => {
        console.log(err);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      });
  };

  const getStatusFirmaTerminada = (
    dataFirmaAnticipada: any,
    dataStatusFirma: ValidateStatus
  ) => {
    if (dataFirmaAnticipada?.error?.length) {
      allResetStateDemandas();
      Swal.fire({
        title: "Advertencia",
        icon: "warning",
        confirmButtonText: "Aceptar",
        html: `<h5>Hubo un problema al terminar la firma , es necesario que generes  nuevamente la solicitud de demanda.</h5>
          <div id="lista-errores"></div>
     `,
      }).then((result) => {
        if (result.isConfirmed) {
          localforage.removeItem("idSolicitud");
          localforage.removeItem("listFiles");
          localforage.removeItem("currentStep");
          localforage.removeItem("certSelected");
          // allResetStateDemandas();
        }
      });
      listaErroresFirma(dataFirmaAnticipada.error);
    }

    if (
      dataFirmaAnticipada.completadas.length &&
      dataStatusFirma.signed.length &&
      dataStatusFirma.signed[0].data.length
    ) {
      startMoveSolicitudToDemanda();
    } else {
      Swal.fire({
        title: "Advertencia",
        icon: "warning",
        confirmButtonText: "Aceptar",
        html: `<h5>Los archivos no se han firmado correctamente, es necesario que generes  nuevamente la solicitud de promoción</h5>
          <div id="lista-errores"></div>
     `,
      }).then((result) => {
        if (result.isConfirmed) {
          localforage.removeItem("idSolicitud");
          localforage.removeItem("listFiles");
          localforage.removeItem("currentStep");
          localforage.removeItem("certSelected");
          allResetStateDemandas();
        }
      });
    }
  };

  const startMoveSolicitudToDemanda = () => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Moviendo solicitud a demanda"));
    postMoveSolicitudToDemanda({
      solicitudDemanda: solicitudDemandaRes?.resultados.idSolicitudActuacion!,
    })
      .then(({ data }) => {
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
        Swal.fire({
          title: "Correcto",
          text: `Se envió la demanda correctamente ${data.data.descJuzgado} con número ${data.data.numExp}/${data.data.aniExp}`,
          icon: "success",
          showCancelButton: true,
          cancelButtonText: "Descargar Acuse",
          cancelButtonColor: "#c62828 ",
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(onSuccessMoveSolcitudToDemanda(true));
          } else if (result.isDismissed) {
            startGetFileAcuse(data.data.acuse.idImagen);
          }
        });
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: `Ha ocurrido un error al mover la demanda`,
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
           <style>
           h4, h5{
             font-family: arial;
             color: #545454;
           }
           #lista-errores{
             overflow:hidden;
           }
         </style>
           <h6 align="center">${err?.response?.data?.error_msg ||
            err?.response?.data?.data ||
            "Hubo un problema"
            }<h6
           <div id="lista-errores"></div>
          `,
        });
        listaErrores(err);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      });
  };

  const startGetFileAcuse = (
    idImagen: number,
    esSolicitudDemandaTabla = false
  ) => {
    getFile(idImagen).then(({ data }) => {
      const fileUrl = window.URL.createObjectURL(
        new Blob([data], { type: "application/pdf" })
      );
      createIframe(fileUrl);
      if (!esSolicitudDemandaTabla) {
        dispatch(onSuccessMoveSolcitudToDemanda(true));
      }
    });
  };

  const startGetFileSolicitudDemandas = (params: any) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Descargando Acuse"));
    getAcuseDemandas(params)
      .then(({ data }) => {
        startGetFileAcuse(data.data[0].idImagen);
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: "Advertencia",
          text: "Ocurrio un error al obtener el acuse",
          icon: "warning",
        });
        dispatch(setIsLoading(false));
        dispatch(setMessageLoading(""));
      });
  };

  const startUpdateSolicitudDemanda = (
    body: BodyUpdateSolicitudDemanda,
    step: number
  ) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Actualizando solicitud demanda"));
    putUpdateSolicitudDemanda(body)
      .then(({ data }) => {
        let bodyResponse = {
          ...data.data,
          actores: data.data.actores.map((actor) => {
            let body = {
              ...actor,
              id: generateRamdomId(),
            };
            return body;
          }),
          demandados: data.data.demandados.map((demandado) => {
            let body = {
              ...demandado,
              id: generateRamdomId(),
            };
            return body;
          }),
          idsCombos: {
            cveRegion: cveRegion,
            cveOficialia: cveOficialia,
            cveMateria: cveMateria,
            cveInstancia: cveInstancia,
            cveVia: cveVia,
            cveJuicio: cveJuicio,
            juzgadoEnLinea: tipoModalidad,
          },
        };
        localforage.setItem("idSolicitud", JSON.stringify(bodyResponse));
        localforage.setItem("currentStep", JSON.stringify(stepDemanda + 1));
        addSolicitudDemanda(bodyResponse);
        addStepDemanda(step);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
        addFormNotas(null);
        addFormSolicitudDemandas(null);
        dispatch(
          setOpenSnackBar({
            status: true,
            message: "La solicitud de demanda fue actualizada correctamente",
          })
        );
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: `Advertencia`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
          <style>
          h4, h5{
            font-family: arial;
            color: #545454;
          }
        </style>
          <h4>${err?.response?.data?.data || "Hubo un problema"}</h4>
          <div id="lista-errores"></div>
         `,
        });
        addFormNotas(null);
        addFormSolicitudDemandas(null);
        addFormNotas(null);
        addFormSolicitudDemandas(null);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      });
  };

  const startGetSolicitudDemanda = (id: number) => {
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Buscando solicitud demanda"));
    getSolicitudDemandaById(id)
      .then(({ data }) => {
        dispatch(onAddSolicitudDemandaSelected(data.data));
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      });
  };

  const startGetSolicitudArchivosDemanda = (id: number) => {
    dispatch(onAddDocumentosListDemanda([]));
    dispatch(setIsLoading(true));
    dispatch(setMessageLoading("Solicitando archivos"));
    getSolicitudDemandaById(id)
      .then(({ data }) => {

        const documentos = Object.values(data.data.archivos);
        // arreglo documentos sin la última posición que es el tamaño de los archivos
        const filteredList = documentos.slice(0, documentos.length - 1);
        addDocumentos(filteredList);
        addPosicion(0);

        startGetFile({ path: data.data.archivos?.[0]?.path });
        openVisorDocumentos(true);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      });
  };

  const startDeleteSolicitudDemanda = (idSolicitudDemanda: number) => {
    dispatch(setMessageLoading("Eliminando solicitud demanda"));
    dispatch(setIsLoading(true));
    deleteSolicitudDemanda(idSolicitudDemanda)
      .then(({ data }) => {
        dispatch(
          setOpenSnackBar({
            status: true,
            message: data.data.message,
          })
        );
        dispatch(onUpdateListSolicitudDemanda(idSolicitudDemanda));
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setOpenSnackBar({
            status: true,
            message: err.response.data.data,
            optionsSnackBar: {
              ...optionsSnackBar,
              type: "error",
            },
          })
        );
        dispatch(setMessageLoading(""));
        dispatch(setIsLoading(false));
      });
  };

  const addRegionId = (id: number | null) => dispatch(onAddRegionId(id));
  const addOficialiaId = (id: number | null) => dispatch(onAddOficialiaId(id));
  const addMateriaId = (id: number | null) => dispatch(onAddMateriaId(id));
  const addInstanciaId = (id: number | null) => dispatch(onAddInstanciaId(id));
  const addViaId = (id: number | null) => dispatch(onAddViaId(id));
  const addJuicioId = (id: number | null) => dispatch(onAddJuicioId(id));
  const resetSelectsDemanda = () => dispatch(onResetSelectsDemanda());

  const changeTipoModalidad = () => dispatch(onChangeTipoModalidad());
  const addTipoModalidad = (status: boolean) =>
    dispatch(onAddTipoModalidad(status));
  const addStepDemanda = (value: number) => dispatch(onAddStepDemanda(value));
  const addCapturaPartesActores = (partes: CapturaPartesInterface[]) =>
    dispatch(onAddCapturaPartesActores(partes));
  const addCapturaPartesDemandados = (partes: CapturaPartesInterface[]) =>
    dispatch(onAddCapturaPartesDemandados(partes));
  const addFormNotas = (form: any) => dispatch(onAddFormNotas(form));
  const addFormSolicitudDemandas = <T>(form: T) =>
    dispatch(onAddFormSolicitudDemandas(form));
  const changeStatusCompleteStepOne = () => dispatch(onCompleteStepOne());
  const addFile = (file: FileBase64 | FileBase64[]) =>
    dispatch(onAddFileStep(file));
  const addSolicitudDemanda = (data: DataSolicitudResponse) =>
    dispatch(onAddSolicitudDemandaRes(data));
  const addListFiles = <T>(listFiles: T) =>
    dispatch(onAddListUploaddedFiles(listFiles));
  const openModalVisor = (status: boolean) =>
    dispatch(onShowModalVisor(status));
  const addFileSelected = (fileUrl: string | null) =>
    dispatch(onAddDocumentSelected(fileUrl));
  const addInitialActoresPartes = (actores: CapturaPartesInterface[]) =>
    dispatch(onAddInitialActoresPartes(actores));
  const addInitialDemandadosPartes = (demandados: CapturaPartesInterface[]) =>
    dispatch(onAddInitialDemandadosPartes(demandados));
  const onModalPermisoLiti = (status: boolean) =>
    dispatch(onPermisoJuicios(status));
  const addSolicitudesDemandas = (demandasList: any) =>
    dispatch(onSolicitudesDemandas(demandasList));

  const allResetStateDemandas = () => dispatch(onAllResetStateDemandas());

  return {
    /**Propiedades **/
    lstRegiones,
    lstOficialias,
    lstMaterias,
    lstInstancias,
    lstVias,
    lstJuicios,
    cveRegion,
    tipoModalidad,
    stepDemanda,
    solicitudesDemandas,
    solicitudesDemandasLaborales,
    formSolicitudDemanda,
    formNotas,
    capturaPartesDemandados,
    capturaPartesActores,
    file,
    listUploaddedFiles,
    showModalVisor,
    documentSelected,
    cveOficialia,
    cveMateria,
    cveVia,
    solicitudDemandaRes,
    successMoveSolicitudToDemanda,
    solicitudDemandaSelected,
    initialCapturaParteActores,
    initialCapturaParteDemandados,
    solicitudDemandaDocumentos,
    modalPermisoLiti,
    /** Métodos **/
    startGetRegiones,
    startGetOficialiaPorRegiones,
    startGetMaterias,
    startGetInstancias,
    startGetVias,
    startGetJuicios,
    addRegionId,
    addOficialiaId,
    addMateriaId,
    addInstanciaId,
    addViaId,
    addJuicioId,
    changeTipoModalidad,
    addStepDemanda,
    startGetSolicitudesDemandas,
    startGetSolicitudesDemandasLaborales,
    addCapturaPartesActores,
    addCapturaPartesDemandados,
    addFormNotas,
    addFormSolicitudDemandas,
    changeStatusCompleteStepOne,
    addFile,
    addListFiles,
    startSaveStepOne,
    addSolicitudDemanda,
    startUploadFileDemanda,
    startDeleteFile,
    startGetFile,
    openModalVisor,
    addFileSelected,
    getStatusFirmaTerminada,
    allResetStateDemandas,
    startUpdateSolicitudDemanda,
    startGetSolicitudDemanda,
    addInitialActoresPartes,
    addInitialDemandadosPartes,
    startMoveSolicitudToDemanda,
    startGetSolicitudArchivosDemanda,
    resetSelectsDemanda,
    startDeleteSolicitudDemanda,
    startGetFileAcuse,
    startGetFileSolicitudDemandas,
    addTipoModalidad,
    addSolicitudesDemandas,
    startPermisosJuicios,
    onModalPermisoLiti,
  };
};
